const initState = {
	showSessionModal: false,
};

export const sessionExpireModal = (state = initState, action) => {
	switch (action.type) {
		case 'open_session_modal':
			return {
				showSessionModal: true,
			};
		case 'close_session_modal':
			return {
				showSessionModal: false,
			};
		default:
			return state;
	}
};
